import { CSSProperties } from "react";
import styled from "styled-components";

interface DemoTagProps {
  isShort?: boolean;
  isSmall?: boolean;
  style?: CSSProperties;
}

const DemoTag = ({ isShort, isSmall, style }: DemoTagProps) => {
  return (
    <Tag style={style} $isSmall={isSmall}>
      {isShort ? "Demo" : "Demo Trading"}
    </Tag>
  );
};

export default DemoTag;

export const Tag = styled.div<{ $isSmall?: boolean }>`
  background: ${(p) =>
    `linear-gradient(114.66deg, ${p.theme.colors.demoTagColors})`};
  border-radius: 50px;
  text-transform: uppercase;
  color: ${(p) => p.theme.colors.layoutBgColor};
  font-weight: ${(p) => p.theme.typography.fontWeights.BOLD};
  padding: 4px 10px;
  width: fit-content;
  white-space: nowrap;
  ${(p) =>
    p.$isSmall &&
    `
   font-size: ${p.theme.typography.fontSizes.S};
   padding: 3px 8px;

  `};
`;
